<template>
  <div class="photo-list-container">
    <common-card :card-title="photoCardTitle">
      <template v-slot:right>
        <div class="manage-album">
          <el-button
            type="text"
            class="none-border"
            size="small"
            plain
            @click="showDeleteImgIcon"
          >{{ manageAlbumTitle }}</el-button>
        </div>
      </template>
      <div class="base-block">
        <div class="photo-container">
          <template v-for="item in albumData">
            <div :key="item.id" class="img-block">
              <span>
                <i
                  v-show="deleteIconShow"
                  style="color: red; z-index: 2000; cursor: pointer"
                  class="el-icon-delete del-img"
                  @click="handleDelete(item.id)"
                />
                <el-image
                  :lazy="true"
                  :style="imageStyle"
                  :src="item.url"
                  :z-index="1000"
                  :preview-src-list="previewList"
                  fit="scale-down"
                />
              </span>
            </div>
          </template>
        </div>
        <el-pagination
          :current-page="page.currentPage"
          :page-sizes="[14, 28, 42, 56]"
          :page-size="page.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="28"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </common-card>
  </div>
</template>

<script>
/**
 * 相册信息
 * @author yang5chao@aliyun.com
 */
import CommonCard from '@/components/CommonCard'
import { getUserAlbum, deleteUserAlbum } from '@/api/user'
export default {
  name: 'PhotoList',
  components: {
    CommonCard
  },
  data() {
    return {
      page: {
        pageSize: 14,
        currentPage: 1
      },
      deleteIconShow: false,
      albumData: {},
      photoCardTitle: '相册列表',
      imageStyle:
        'width: 150px; height: 150px;margin-left:26px;margin-bottom:26px'
    }
  },
  computed: {
    previewList() {
      return this.albumData.map((item) => item.url)
    },
    manageAlbumTitle() {
      return this.deleteIconShow ? '取消' : '管理相册'
    }
  },
  beforeMount() {
    this.onLoad(this.page)
  },

  methods: {
    onLoad(page) {
      const {userId} = this.$route.query
      const {pageSize,currentPage} = this.page;
      getUserAlbum({page:currentPage,limit:pageSize,userId}).then((res) => {
        this.albumData = res.data
        this.page.total = res.total
      })
    },
    handleSizeChange(pageSize) {
      this.page.pageSize = pageSize
    },
    handleCurrentChange(currentPage) {
      this.page.currentPage = currentPage
      this.$nextTick(() => {
        this.onLoad(this.page)
      })
    },
    showDeleteImgIcon() {
      this.deleteIconShow = !this.deleteIconShow
    },
    handleDelete(id) {
      // 弹窗确认是否删除
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const { userId } = this.$route.query
          deleteUserAlbum({ userId, id }).then(() => {
            this.albumData = this.albumData.filter(item => item.id != id)
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.photo-list-container {
  margin-top: 1.2rem;
  .manage-album {
    margin-right: 30px;
    .none-border {
      color: red;
      border: 0;
      background-color: transparent !important;
    }
  }
  .base-block {
    display: flex;
    flex-direction: column;
    align-items: center;
    .photo-container {
      margin-top: 18px;
      display: flex;
      align-content: flex-start;
      flex-wrap: wrap;
      .img-block {
        position: relative;
        .del-img {
          position: absolute;
          top: 0px;
          left: 150px;
        }
      }
    }
  }
}
</style>>

